module.exports = __webpack_public_path__ + "static/media/card-back.38de9848.png";